// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/ui/confirmPop.less
// module id = 1847
// module chunks = 153